export interface Contact {
  id?: number;
  mediaNo: number;
  mediaType: string;
  contactType?: string;
  contactDetails: string;
}
